module.exports = __webpack_public_path__ + "img/phone.e559b42c.svg";